export default __webpack_public_path__ + "static/foto2-d4083aea432563aef2f97df6496e1abc.jpg";